var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-select" },
    [
      _c(
        "div",
        {
          staticClass: "cost-select el-textarea el-input--small",
          class: { "disabled-select": _vm.disabled },
          staticStyle: { "min-height": "32px" },
          on: { click: _vm.openModal },
        },
        _vm._l(_vm.value, function (item, index) {
          return _c(
            "el-tag",
            {
              key: index,
              attrs: { closable: !_vm.disabled },
              on: {
                close: function ($event) {
                  return _vm.handleClose(item)
                },
              },
            },
            [_vm._v(_vm._s(item.positionLevelName))]
          )
        }),
        1
      ),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }